import React, { useState } from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";
import ConfirmModalContainer from "../ConfirmModalContainer/ConfirmModalContainer";

const AddQuestionnaireMobileContainer = () => {
  const [openModal, setOpenModal] = useState(true);
  const navigate = useNavigate();
  const intl = useIntl();
  return (
    <ConfirmModalContainer
      hideButton
      open={openModal}
      setOpen={setOpenModal}
      question={getLocalizedMessage(
        intl,
        "questionnaire.addQuestionnaireWarningMobile"
      )}
      iconSrc={"/icons/warningIcon.svg"}
      onClose={() => {
        navigate("/questionnaire");
      }}
    />
  );
};

export default AddQuestionnaireMobileContainer;
